"use strict";
exports.__esModule = true;
var _1ds_cv_js_1 = require("@microsoft/1ds-cv-js");
var Logging_1 = require("../Logging");
var DeviceInteractionVector = (function () {
    function DeviceInteractionVector() {
        this.PendingExtension = false;
        this.deviceInteractionVector = new _1ds_cv_js_1.Cv();
    }
    DeviceInteractionVector.prototype.CanUpdate = function (allowExtension) {
        if (allowExtension === void 0) { allowExtension = false; }
        var hasRoom;
        if (this.PendingExtension && allowExtension) {
            hasRoom = this.deviceInteractionVector.canExtend();
            Logging_1.console_assert(hasRoom === this.deviceInteractionVector.canIncrement(), "If there was room to extend, there should be room to increment");
        }
        else {
            hasRoom = this.deviceInteractionVector.canIncrement();
        }
        return hasRoom;
    };
    DeviceInteractionVector.prototype.UpdateAndGet = function (allowExtension) {
        if (allowExtension === void 0) { allowExtension = true; }
        if (this.PendingExtension && allowExtension) {
            this.deviceInteractionVector.extend();
            this.PendingExtension = false;
        }
        this.deviceInteractionVector.increment();
        return this.deviceInteractionVector.getValue();
    };
    DeviceInteractionVector.prototype.Get = function () {
        return this.deviceInteractionVector.getValue();
    };
    DeviceInteractionVector.prototype.Reseed = function () {
        this.PendingExtension = false;
        this.deviceInteractionVector = new _1ds_cv_js_1.Cv();
    };
    return DeviceInteractionVector;
}());
exports.DeviceInteractionVector = DeviceInteractionVector;
//# sourceMappingURL=DeviceInteractionVector.js.map